import gql from "graphql-tag";
import { SOURCE_FILE_PROPS } from "./Component";

export const CREATE_SOURCE_FILE_COMPONENT = gql`
mutation createSourceFileComponent(
    $partyId: ID!,
    $projectId: ID!,
    $componentInput: SourceFileInput, 
    $fileInput: FileInput,
    $componentGroup: String!,
    $componentGroupOrderWeight: Int!, 
    $componentOrderWeight: Int!
    $fullFileKey: String!
    )
{
    CreateSourceFileComponent(
      partyId: $partyId,
      projectId: $projectId,
      componentInput: $componentInput,
      fileInput: $fileInput,
      componentGroup: $componentGroup,
      componentGroupOrderWeight: $componentGroupOrderWeight
      componentOrderWeight: $componentOrderWeight
      fullFileKey: $fullFileKey
      )
    {
      ${SOURCE_FILE_PROPS}
      versions: versionsInProject {
        ...on SourceFile {
          ${SOURCE_FILE_PROPS}
          versions: versionsInProject {
            id
          }
        }
      }
    }
  }
`;

export const GET_SOURCEFILE = gql`
query getSourceFile(
  $personId: ID!
  $projectId: ID!
  $referenceId: ID!
){
  SourceFile(
    personId: $personId
    projectId: $projectId
    referenceId: $referenceId
  ) {
    ${SOURCE_FILE_PROPS}
  }
}
`;

export const CREATE_SOURCE_FILE_REFERENCE = gql`
mutation createSourceFileReference(
    $partyId: ID!,
    $projectId: ID!,
    $componentInput: SourceFileInput, 
    $fileInput: FileInput,
    $fullFileKey: String!
    )
{
    CreateSourceFileReference(
      partyId: $partyId,
      projectId: $projectId,
      componentInput: $componentInput,
      fileInput: $fileInput,
      fullFileKey: $fullFileKey
      )
    {
      ${SOURCE_FILE_PROPS}
      versions: versionsInProject {
        ...on SourceFile {
          ${SOURCE_FILE_PROPS}
          versions: versionsInProject {
            id
          }
        }
      }
    }
  }
`;

export const CREATE_VERSION_OF_SOURCE_FILE_REFERENCE = gql`
mutation createVersionOfSourceFileReference(
    $partyId: ID!,
    $projectId: ID!,
    $componentInput: SourceFileInput, 
    $fileInput: FileInput,
    $componentGroup: String!,
    $componentGroupOrderWeight: Int!, 
    $componentOrderWeight: Int!,
    $parentComponentId: ID!
    $fullFileKey: String!
    )
{
    CreateVersionOfSourceFileReference(
      partyId: $partyId,
      projectId: $projectId,
      componentInput: $componentInput,
      fileInput: $fileInput,
      componentGroup: $componentGroup,
      componentGroupOrderWeight: $componentGroupOrderWeight
      componentOrderWeight: $componentOrderWeight
      parentComponentId: $parentComponentId
      fullFileKey: $fullFileKey
      )
    {
      ${SOURCE_FILE_PROPS}
      versions: versionsInProject {
        ...on SourceFile {
          ${SOURCE_FILE_PROPS}
          versions: versionsInProject {
            id
          }
        }
      }
    }
  }
`;

export const CREATE_VERSION_OF_SOURCE_FILE_COMPONENT = gql`
mutation createVersionOfSourceFileComponent(
    $partyId: ID!,
    $projectId: ID!,
    $componentInput: SourceFileInput, 
    $fileInput: FileInput,
    $componentGroup: String!,
    $componentGroupOrderWeight: Int!, 
    $componentOrderWeight: Int!,
    $parentComponentId: ID!
    $fullFileKey: String!
    )
{
    CreateVersionOfSourceFileComponent(
      partyId: $partyId,
      projectId: $projectId,
      componentInput: $componentInput,
      fileInput: $fileInput,
      componentGroup: $componentGroup,
      componentGroupOrderWeight: $componentGroupOrderWeight
      componentOrderWeight: $componentOrderWeight
      parentComponentId: $parentComponentId
      fullFileKey: $fullFileKey
      )
    {
      ${SOURCE_FILE_PROPS}
      versions: versionsInProject {
        ...on SourceFile {
          ${SOURCE_FILE_PROPS}
          versions: versionsInProject {
            id
          }
        }
      }
    }
  }
`;

export const UPDATE_SOURCE_FILE_COMPONENT = gql`
mutation updateSourceFileComponent(
  $input: UpdateComponentInput!
  )
  {
  UpdateSourceFileComponent(
    input: $input
    ) {
      ${SOURCE_FILE_PROPS}
      versions: versionsInProject {
        ...on SourceFile {
          ${SOURCE_FILE_PROPS}
          versions: versionsInProject {
            id
          }
        }
      }
    }
  }
`;

export const DELETE_SOURCEFILE = gql`
  mutation deleteSourceFile (
    $personId: ID!,
    $referenceId: ID!
  ) {
    DeleteSourceFile(
      personId: $personId,
      referenceId: $referenceId
  ) {
    id
  }
}
`;

export const ADD_SOURCE_FILE_COMPONENT_CREATOR = gql`
  mutation addSourceFileComponentCreator(
    $personId: ID!
    $projectId: ID!
    $sourceFileId: ID!
    $otherPersonId: ID!
  ) {
    AddSourceFileComponentCreator(
      personId: $personId
      projectId: $projectId
      sourceFileId: $sourceFileId
      otherPersonId: $otherPersonId
    ) {
      id
      title
      subtitle
      version
      creationDate {
        formatted
      }
      creationDateIsApproximate
      lastModifiedDate {
        formatted
      }
      type
      proprietaryId
      proprietaryIdNamespace
      status
      url
      isArchived
      software
      project {
        id
      }
      comments {
        id
        creationDate {
          formatted
        }
        author {
          id
          fullName
          accountId
          imageDepictions {
            id
            file {
              uri
            }
          }
        }
      }
      genres {
        id
      }
      contributions {
        id
      }
      isContributionOf {
        id
      }
      rightShares {
        id
      }
      file {
        id
        uri
      }
      versions {
        id
      }
      isVersionOf {
        id
      }
      mood {
        id
      }
      equipment {
        id
      }
    }
  }
`;
